export class VarianceStatusPostCommand{
    Id:string;
    nextStatus:string;

    constructor(varianceId:string, nextStatus:string){
        this.Id = varianceId;
        this.nextStatus = nextStatus;
    }
}